import React, { useState, useEffect, useContext } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { getClientbyLcationAsync } from "../../../api/Dashboard";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { isEmpty } from "lodash";
import NoData from "../../../components/NoData";
import { chartPalette, monoFont } from "../../../theme";

const ClientsByLocation = ({ selectedSucursal }) => {
  const [datos, setDatos] = useState([]);
  const [total, setTotal] = useState(0);

  const { setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getClientbyLcationAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);

      setDatos(result.data.result);
      let suma = 0;
      result.data.result.map((item) => (suma += item.contador));
      setTotal(suma);
    })();
  }, [selectedSucursal]);

  const palette = chartPalette(isDarkMode, Math.max(datos.length, 1));

  return (
    <div>
      {isEmpty(datos) ? (
        <NoData />
      ) : (
        <Stack spacing={2}>
          {datos.map((item, index) => {
            const pct = total > 0 ? Math.round((item.contador / total) * 100) : 0;
            return (
              <Box key={item.location}>
                <Stack direction="row" justifyContent="space-between" sx={{ marginBottom: "6px" }}>
                  <Typography sx={{ fontSize: 12.5, fontWeight: 500, color: "text.secondary" }}>{item.location}</Typography>
                  <Typography sx={{ fontFamily: monoFont, fontSize: 12.5, fontWeight: 600 }}>{item.contador}</Typography>
                </Stack>
                <Box sx={{ height: 8, borderRadius: "6px", backgroundColor: "action.hover", overflow: "hidden" }}>
                  <Box sx={{ height: "100%", width: `${pct}%`, borderRadius: "6px", backgroundColor: palette.border[index % palette.border.length] }} />
                </Box>
              </Box>
            );
          })}
        </Stack>
      )}
    </div>
  );
};

export default ClientsByLocation;
